import React from 'react';
import { Button, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import CountryList from "country-list";

const data = new CountryList().getData().map((c, index) => ({ ...c, index: index + 1 }));

const renderCountry = (c, { handleClick, modifiers, query}) => {
    if (!modifiers.matchesPredicate)
        return (null);
    const text = `${c.name}`;

    return (
        <MenuItem 
            active={modifiers.active}
            disabled={modifiers.disabled}
            key={c.index}
            label={c.code}
            onClick={handleClick}
            text={text}
        />
    )
}

const predicateCountry = (query, c) => {
    return (`${c.name.toLowerCase()}`.indexOf(query.toLowerCase()) >= 0);
}

class CountriesSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            country: null
        }
    }

    handleItemSelect = (country) => {
        const { onItemSelect } = this.props;

        this.setState({ country });
        if (!onItemSelect)
            return ;
        onItemSelect(country.name);
    }

    render() {
        const { country } = this.state;

        return (
            <Select
                className="select-countries"
                items={data}
                itemPredicate={predicateCountry}
                itemRenderer={renderCountry}
                itemDisabled={(c) => c.disable === true}
                onItemSelect={this.handleItemSelect}
                noResults={<MenuItem disabled={true} text="Aucun pays trouvé..." />}
            >
                <Button 
                    fill={true} 
                    text={country ? country.name : 'Choisir un pays'} 
                    rightIcon="double-caret-vertical"
                />
            </Select>
        );
    }
}

export { CountriesSelect };
